export class OverrideEmail {
    oldEmail: string;
    newEmail: string;
    companyId: number;
    roleId: number;
}